var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-slider__marks-text",style:(this.mark.style),attrs:{"data-insp-path":"output/src/components-new/slider/src/marker.vue:2:3:div"}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }